module.exports = __webpack_public_path__ + "static/media/stackoverflow.da29de89.svg";